// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"4df1380b","455":"5268cc39","488":"430ef3d7","977":"34b182f7"}[chunkId] + ".chunk.js";
};